import API from '@/lib/API.js'
import comun from './comun.js'
const motivosdebajaempresas = {
    namespaced: true,
    state: {
        Lista: [],
        Seleccionado: undefined
    },
    mutations: {
        init(state) {
            state.Seleccionado = undefined
        },
        set(state, payload) {
            state.Lista = payload;
        },
        select(state, payload) {
            state.Seleccionado = payload;
        }
    },
    actions: {
        async set({
            commit,
            getters
        }) {
            let entidades = getters.get();
            if (entidades.length === 0) {
                commit("comun/cargando")
                let data = await API.Motivo_baja_empresa.traerTodos();
                commit("set", data)
                commit("comun/fincarga")
            }
        },
        select({
            commit
        }, payload) {
            commit("select", payload)
        },
        selectPorId({
            commit,
            state
        }, payload) {
            commit("comun/cargando")
            let motivo = state.Lista.find((x) => x.id_motivo_baja == payload)
            commit("select", motivo)
            commit("comun/fincarga")
        },
        setNuevo({
            commit
        }) {
            commit("comun/cargando")
            let sec = {
                id_motivo_baja: 0,
                descripcion_baja_empresa: ""
            }
            commit("select", sec)
            commit("comun/fincarga")
        },
        async guardar({
            commit,
            dispatch,
            state
        }) {
            let data = []
            let str = ""
            if (state.Seleccionado.id_motivo_baja != 0) {
                data = await API.Motivo_baja_empresa.modificar(state.Seleccionado);
                str += "Motivo modificado"
            } else {
                data = await API.Motivo_baja_empresa.alta(state.Seleccionado);
                str += `nuevo Motivo de alta '${data.descripcion_baja_empresa}'`
            }
            let secs = await API.Motivo_baja_empresa.traerTodos();
            commit("set", secs)
            dispatch("selectPorId", data.id_motivo_baja)
            commit("comun/mostrar", str)
        },
        async guardarEntidad({
            commit,
            dispatch,
            state
        }, entidad) {
            //commit("comun/cargando")
            let data = []
            let str = ""
            if (entidad.id_motivo_baja != 0) {
                data = await API.Motivo_baja_empresa.modificar(entidad);
                str += "Motivo modificado"
            } else {
                data = await API.Motivo_baja_empresa.alta(entidad);
                str += `nuevo Motivo de alta '${data.descripcion_baja_empresa}'`
            }
            let secs = await API.Motivo_baja_empresa.traerTodos();
            commit("set", secs)
            //commit("select", data)
            dispatch("selectPorId", data.id_motivo_baja)
            //commit("comun/fincarga")
            commit("comun/mostrar", str)
        },
        async eliminar({
            commit
        }, id) {
            let str = ""
            if (id != 0) {
                await API.Motivo_baja_empresa.eliminar(id);
                str += "Motivo eliminado"
            }
            let ents = await API.Motivo_baja_empresa.traerTodos();
            commit("set", ents)
            commit("comun/mostrar", str)
        },
    },
    getters: {
        get: state => () => {
            return state.Lista;
        },
    },
    modules: {
        comun,
    }

}
export default motivosdebajaempresas;